import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import CapabilityMarquee from "@/components/sections/CapabilityMarquee";
import Services from "@/components/sections/Services";
import Vision from "@/components/sections/Vision";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <About />
      <CapabilityMarquee />
      <Services />
      <Vision />
    </div>
  );
}
